import React from 'react';

import { formatNumber } from '../my_time_record/timeUnits';

import { DASH, formatTotalValue, shortUnit, toUnit } from './summaryUnits';

/**
 * The same tile as the time report's KPIs: a large figure with its unit, then a
 * line saying what it counts.
 */
function TimeSummaryTile({ value, suffix, caption }) {
    return (
        <div className="tw-px-4 tw-py-3 tw-rounded-lg tw-border-2 tw-border-grey tw-bg-white">
            <div className="tw-flex tw-items-baseline tw-gap-1.5">
                <span className="tw-text-2.5xl tw-font-semibold tw-text-blue">{value}</span>
                {!!suffix && <span className="tw-text-sm tw-text-charcoal-50">{suffix}</span>}
            </div>
            <div className="tw-text-sm tw-text-charcoal-75 tw-mt-1">{caption}</div>
        </div>
    );
}

export default function TimeSummaryTiles({ tiles, unit, hoursInDay }) {
    const short = shortUnit(unit);
    // Divided after converting, not converted after the server's rounded
    // average: 5.17 days × 8 is 41.36 h, where the true figure is 41.33 h.
    const average = tiles.submitted > 0 ? formatNumber(toUnit(tiles.submitted_total, unit, hoursInDay) / tiles.submitted) || '0' : DASH;

    return (
        <div className="tw-grid tw-grid-cols-1 tw-gap-4 sm:tw-grid-cols-2 lg:tw-grid-cols-4">
            <TimeSummaryTile value={tiles.submitted} suffix={$t('of {{count}} weeks', { count: tiles.weeks })} caption={$t('Submitted')} />
            <TimeSummaryTile
                value={tiles.draft}
                suffix={tiles.draft === 1 ? $t('week') : $t('weeks')}
                caption={tiles.draft_label ? $t('Still in draft — {{week}}', { week: tiles.draft_label }) : $t('Still in draft')}
            />
            <TimeSummaryTile value={formatTotalValue(tiles.total, unit, hoursInDay)} suffix={short} caption={$t('Recorded in period')} />
            <TimeSummaryTile value={average} suffix={$t('{{unit}} / week', { unit: short })} caption={$t('Average on submitted weeks')} />
        </div>
    );
}
